module.exports = require("./uz-Arab.d.ts");